module.exports = "/_next/static/images/pos_indonesia_ic-b98e122b12a1ae76970ebbdfea3571c4.svg";